(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('DeleteContactDialogController', DeleteContactDialogController);

    function DeleteContactDialogController($scope, $mdDialog, $translate, $sce, $sanitize) {

        $scope.permanentlyDeleteContact = function () {

            return $mdDialog.hide({ showPermanentDeleteConfirmationDialog: true });
        };

        /**
         * Returns sanitized and trusted HTML for the delete-contact warning text with link.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getDeleteContactWarningHtml = function () {
            // eslint-disable-next-line quotes
            const raw = $translate.instant("Deleting the contact will still show the contact on the account it's linked to (greyed out). It will retain its interactions in the timeline until you remove it from the account. To permanently delete the contact, click on <a href=''>permanent delete</a>.");
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Delegates clicks on the "permanent delete" link (inside ng-bind-html).
         *
         * @param {Object} $event - Click event
         */
        $scope.handleDeleteContactWarningClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                $scope.permanentlyDeleteContact();
            }
        };

        $scope.confirm = $mdDialog.hide;

        $scope.cancel = $mdDialog.cancel;
    }
})();
